/**
 * Severity Calculator - Calcula severidad basada en CVSS
 * 
 * Usa CVSSVectorCalculator para calcular vectores y scores dinámicamente
 * basándose en evidencias del evento detectado.
 */ 

import CVSSVectorCalculator from './cvss-vector-calculator.js';

export class SeverityCalculator {
	constructor(catalog) {
		this.catalog = catalog;
		this.vectorCalculator = new CVSSVectorCalculator();
	}

	calculate(eventType, variant = null, context = {}) {
		if (!this.catalog[eventType]) {
			return this.getDefaultResult('medium');
		}

		const eventDef = this.catalog[eventType];
		
		let severity = eventDef.baseSeverity;
		let cvssBaseScore = eventDef.cvssBaseScore;
		
		let mitreTechnique = eventDef.mitreTechnique;

		if (variant && eventDef.variants && eventDef.variants[variant]) {
			const variantDef = eventDef.variants[variant];
			severity = variantDef.severity || severity;
			cvssBaseScore = variantDef.cvssBaseScore || cvssBaseScore;
			if (variantDef.mitreTechnique) mitreTechnique = variantDef.mitreTechnique;
		}

		const cvssVector = this.vectorCalculator.calculateVector(eventType, variant, context);
		const cvssScore = this.vectorCalculator.calculateScore(cvssVector);

		const result = {
			severity: severity,
			cvssScore: cvssScore,
			cvssVector: cvssVector,
			owaspCategory: eventDef.owaspCategory,
			cweId: eventDef.cweId,
			mitreTechnique: mitreTechnique,
			variant: variant || null
		};

		return result;
	}

	getDefaultResult(severity = 'medium') {
		return {
			severity: severity,
			cvssScore: severity === 'critical' ? 9.0 : severity === 'high' ? 7.5 : severity === 'medium' ? 5.5 : 3.0,
			cvssVector: null,
			owaspCategory: null,
			cweId: null,
			mitreTechnique: null,
			variant: null
		};
	}
}

export default SeverityCalculator;
